var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocXml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#F1F1F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#14A344"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.019 33C25.082 33 25.1 32.946 25.073 32.892L23.237 29.841L24.947 26.988C24.974 26.934 24.956 26.88 24.893 26.88H23.642C23.57 26.88 23.534 26.907 23.498 26.97L22.526 28.626H22.499L21.527 26.97C21.491 26.907 21.455 26.88 21.383 26.88H20.132C20.069 26.88 20.051 26.934 20.078 26.988L21.779 29.841L19.952 32.892C19.916 32.946 19.943 33 20.006 33H21.248C21.329 33 21.365 32.973 21.401 32.91L22.499 31.047H22.526L23.615 32.91C23.651 32.973 23.687 33 23.768 33H25.019ZM25.7725 32.91C25.7725 32.964 25.8085 33 25.8625 33H26.8795C26.9335 33 26.9695 32.964 26.9695 32.91V29.463H27.0055L28.1395 32.046C28.1755 32.127 28.2295 32.163 28.3105 32.163H28.9315C29.0125 32.163 29.0665 32.127 29.1025 32.046L30.2365 29.463H30.2725V32.91C30.2725 32.964 30.3085 33 30.3625 33H31.3795C31.4335 33 31.4695 32.964 31.4695 32.91V26.97C31.4695 26.916 31.4335 26.88 31.3795 26.88H30.3265C30.2545 26.88 30.2095 26.907 30.1825 26.97L28.6615 30.462H28.6255L27.0775 26.97C27.0505 26.907 27.0055 26.88 26.9335 26.88H25.8625C25.8085 26.88 25.7725 26.916 25.7725 26.97V32.91ZM32.6368 32.91C32.6368 32.964 32.6728 33 32.7268 33H36.7138C36.7678 33 36.8038 32.964 36.8038 32.91V31.911C36.8038 31.857 36.7678 31.821 36.7138 31.821H34.0138C33.9778 31.821 33.9598 31.803 33.9598 31.767V26.97C33.9598 26.916 33.9238 26.88 33.8698 26.88H32.7268C32.6728 26.88 32.6368 26.916 32.6368 26.97V32.91Z",
    fill: "#787A8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocXml);
export default __webpack_public_path__ + "static/media/doc-xml.4bd70926.svg";
export { ForwardRef as ReactComponent };